const FormatGender = (gender: string = "") => {
  switch (gender) {
    case "M":
      return "Male"
    case "F":
      return "Female"
    default:
      return "Unknown"
  }
}

export default FormatGender
